// removed by extract-text-webpack-plugin
module.exports = {"list":"_38WOqKd5gDRYS3mCBLWVsX","bottomContainer":"fhMjMONTC8lrouWmiTsVV","buttonContainer":"wBj0col8tSQm-GLZecG5s","addBar":"_3EL_Xm2hKzIB1p8eEdjwuF","topBars":"_3uXnIsVkArmvzgRHcVihXD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MyPlaylistsSelectPopup/MyPlaylistsSelectPopup.scss
// module id = 624
// module chunks = 1